import React from 'react'
import { Icon } from 'antd'
import './index.css'

const Loader = ({ title = 'Loading', message }) => (
  <div className="loader-panel">
    <Icon type="loading" spin className="loader-panel__icon" />
    <h2 className="loader-panel__title">{title}</h2>
    {message ? <p className="loader-panel__message">{message}</p> : null}
  </div>
)

export default Loader
